import React from 'react';
import {PcAgeRange} from './pc/PcAgeRange';
import {MobileAgeRange} from './mobile/MobileAgeRange';
import {landingAgeSelect} from "../../../../tracking/external";

function AgeRange({isMobile, ...props}) {
    // wrap clickNext with tracking
    const handleClickNext = (age) => {
        landingAgeSelect();
        if (props.clickNext) {
            props.clickNext(age);
        }
    };

    const commonProps = {
        ...props,
        clickNext: handleClickNext,
        clickPrev: props.clickPrev || (() => {})
    };

    if (isMobile) {
        return <MobileAgeRange {...commonProps} />;
    } else {
        return <PcAgeRange {...commonProps} />;
    }
}

export default AgeRange;